var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 1.908L5.15412 8.76L2.61012 6.216L3.45612 5.37L5.15412 7.068L11.1541 1.068L12.0001 1.908ZM10.6741 4.932C10.7521 5.274 10.8001 5.634 10.8001 6C10.8001 8.652 8.65212 10.8 6.00012 10.8C3.34812 10.8 1.20012 8.652 1.20012 6C1.20012 3.348 3.34812 1.2 6.00012 1.2C6.94812 1.2 7.82412 1.476 8.56812 1.95L9.43212 1.086C8.46012 0.402 7.27812 0 6.00012 0C2.68812 0 0.00012207 2.688 0.00012207 6C0.00012207 9.312 2.68812 12 6.00012 12C9.31212 12 12.0001 9.312 12.0001 6C12.0001 5.286 11.8681 4.602 11.6401 3.966L10.6741 4.932Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolution);
export default __webpack_public_path__ + "static/media/solution.2309e6ed600bfe3226081bb8eefaadac.svg";
export { ForwardRef as ReactComponent };